import CobraSpinner from './CobraSpinner';
import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useDisclosure} from "@chakra-ui/react";
import axiosInstance from "../services/axiosInstance";

const isArabic = (text) => /[\u0600-\u06FF]/.test(text);

const SurveyStatisticsPopup = ({ surveyId, onClose }) => {
  const { isOpen, onOpen, onClose: closeModal } = useDisclosure();
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (surveyId) {
      onOpen();
      fetchStatistics(surveyId);
    }
  }, [surveyId]);

  const fetchStatistics = async (surveyId) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/surveys/${surveyId}/statistics`);
      setStatistics(response.data.questions);
    } catch (error) {
      console.error("خطأ في جلب الإحصائيات", error); // Translated error message
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    closeModal();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent dir="rtl"> {/* Added dir="rtl" */}
        <ModalHeader textAlign="right">إحصائيات الاستبيان</ModalHeader> {/* Translated and aligned right */}
        <ModalCloseButton />
        <ModalBody>
          {loading ? (
            <Box textAlign="center" py={4}>
              <CobraSpinner size="xl" />
              <Text mt={2}>جاري تحميل الإحصائيات...</Text> {/* Translated */}
            </Box>
          ) : statistics ? (
            statistics.map((stat, index) => {
              const isRTL = isArabic(stat.questionText);
              return (
                <Box
                  key={index}
                  mb={6}
                  dir={isRTL ? "rtl" : "ltr"}
                  textAlign={isRTL ? "right" : "left"}
                >
                  <Text fontSize="lg" fontWeight="bold" mb={4}>
                    {stat.questionText}
                  </Text>
                  <Table variant="striped" colorScheme="blue" size="sm">
                    <Thead>
                      <Tr>
                        <Th textAlign={isRTL ? "right" : "left"}>الإجابة</Th> {/* Translated and aligned */}
                        <Th textAlign={isRTL ? "right" : "left"}>الردود</Th> {/* Translated and aligned */}
                      </Tr>
                    </Thead>
                    <Tbody>
                      {Object.entries(stat.responseDetails).map(
                        ([answer, count]) => (
                          <Tr key={answer}>
                            <Td textAlign={isRTL ? "right" : "left"}>{answer}</Td> {/* Aligned */}
                            <Td textAlign={isRTL ? "right" : "left"}>{count}</Td> {/* Aligned */}
                          </Tr>
                        )
                      )}
                    </Tbody>
                  </Table>
                </Box>
              );
            })
          ) : (
            <Text textAlign="right">لا توجد إحصائيات متاحة لهذا الاستبيان.</Text> 
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SurveyStatisticsPopup;



